"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAMPAIGN_METRICS_OFFICER_API_PATH = exports.CAMPAIGN_METRICS_API_PATH = exports.CAMPAIGN_API_PATH = void 0;
const constants_1 = require("../../constants/constants");
exports.CAMPAIGN_API_PATH = `schedules/campaigns/${constants_1.CAMPAIGN_ID_TEMPLATE_TAG}/`;
exports.CAMPAIGN_METRICS_API_PATH = `schedules/campaigns/${constants_1.CAMPAIGN_ID_TEMPLATE_TAG}/metrics/`;
exports.CAMPAIGN_METRICS_OFFICER_API_PATH = `schedules/campaigns/metrics/officer/`;
exports.default = 'schedules/campaigns/list/';
